import { query } from '../utilities';

export const catalogPrices = (products,isCashback = false) => {
    return query('/catalog/prices/', {
        params: { products, isCashback}
    });
};
